import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Routes,
} from "react-router-dom";
import PackageCard from "./PackageCard";

const Discover = () => {
  return <PackageCard />;
};

export default Discover;
